import { defineComponent as _defineComponent } from 'vue'
import { useExchInfo } from '@/hooks/use-exch-info';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { ExchButtonStatus } from '@/types/exch-info';
import { TaskReceiveStatus } from './hooks/use-task-info';
import { biClick } from '@tencent/fit-bi-sdk';
import { CustomException } from '@tencent/ppd-base-libs';
import { CouponDetailDialog } from '@tencent/wphk-act-base-ui';
import { to } from '@tencent/wphk-base-utils';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { goCouponDetail } from '@tencent/wphk-components-jump-page/src/jump-page';
import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import { showToast } from '@tencent/wphk-components-toast';
import { OkIcon } from '@tencent/wphk-icon-vue';
import { AmountBox } from '@tencent/wphk-ui';
import { PropType, Ref, computed, ref, watchEffect } from 'vue';
import { PayActItem, PayActType, joinTask, receiveCoupon, refreshPayAct } from './business/pay-act';
import { ICON_CONFIG } from './config';
import { usePayActItem } from './hooks/use-pay-act-item';
import { useActConfigStore } from '../../store/act-config';


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-act-item',
  props: {
  payActInfo: {
    type: Object as PropType<PayActItem>,
    required: true,
  },
},
  emits: ['joinSuccess'],
  setup(__props, { emit }) {

const props = __props



const { targetActConfig } = useActConfigStore();
const refCouponDetail: Ref<InstanceType<typeof CouponDetailDialog> | null> = ref(null);
const { discount } = useExchInfo({ exchInfo: props.payActInfo.exchInfo });
const actItemHooks = ref({} as any);
const { getBiExt } = useGlobalBi();
const extraBi = computed(() => {
  const biExt = {
    ...getBiExt(),
    ftaskType: props.payActInfo?.actType || '',
    ftaskName: props.payActInfo.taskInfo?.taskName || '',
    ftaskStatus: actItemHooks.value?.taskReceiveStatus || '',
  };
  return biExt;
});

watchEffect(() => {
  actItemHooks.value = usePayActItem(props.payActInfo);
});

const handleReceiveCoupon = async (payActItem: PayActItem) => {
  showLoading();
  const [err] = await to(receiveCoupon(payActItem));
  to(refreshPayAct({ taskName: targetActConfig?.payTaskModule.taskName }));
  hideLoading();
  if (err) {
    showBusinessError(err);
    throw new CustomException(
      err,
      'PayActGetCouponFail',
      `${payActItem.enActId};execState:${(err as any)?.options?.execState}`,
    );
  }
};

const joinTaskAndReceiveCoupon = async (payActItem: PayActItem) => {
  showLoading();
  const [joinTaskErr, joinRes] = await to(joinTask());
  hideLoading();
  if (joinTaskErr) {
    showBusinessError('活動火爆，請再嘗試');
    throw new CustomException(joinTaskErr, 'PayActJoinTaskFail', props.payActInfo.enActId);
  }
  await handleReceiveCoupon(payActItem);
  if ((joinRes as any)?.status === 'hasJoined') {
    /** 如果曾经已报名成功，则不播放动画 */
    showToast({
      title: '領取成功',
      duration: 1000,
    });
    return;
  }
  // 通知外部：播动画,弹弹窗
  emit('joinSuccess');
};

/** 点击详情弹窗中按钮 */
const onClickDetailBtn = async () => {
  biClick('pay-act-item.detail-btn-click|详情弹窗按钮点击', extraBi.value);
  refCouponDetail.value?.hideDialog();
  const btnStatus: ExchButtonStatus = actItemHooks.value.buttonStatus;
  // 如果“立即领取”，那么执行领取（判断actType为exc或者task)
  if ([ExchButtonStatus.Hidden, ExchButtonStatus.IsLimit, ExchButtonStatus.IsLocked].includes(btnStatus)) {
    return;
  }
  if (btnStatus === ExchButtonStatus.ToReceive) {
    if (props.payActInfo.actType === PayActType.exch) {
      await joinTaskAndReceiveCoupon(props.payActInfo);
    } else {
      await handleReceiveCoupon(props.payActInfo);
      // 领取成功提示
      showToast({
        title: '領取成功',
        duration: 1000,
      });
    }
    return;
  }
  if (btnStatus === ExchButtonStatus.ToUse) {
    goCouponDetail({ userScid: props.payActInfo.exchInfo.userCouponid!, adtag: 'channel-payAct' });
  }
};
/** 点击icon下方的【领取】按钮 */
const onClickIconBtn = async () => {
  biClick('pay-act-item.receive-icon-click|icon下方领取按钮点击', extraBi.value);

  if (props.payActInfo.actType === PayActType.exch) {
    joinTaskAndReceiveCoupon(props.payActInfo);
  } else {
    // 打开券弹窗
    // @ts-ignore
    biClick('pay-act-item.detail_dialog_brow|券详情弹窗曝光', extraBi.value);
    refCouponDetail.value?.showDialog();
  }
};
const onClickItem = () => {
  biClick('pay-act-item.icon-click|任务icon点击', extraBi.value);
  // @ts-ignore
  refCouponDetail.value?.showDialog();
};


return { __sfc: true,props, emit, targetActConfig, refCouponDetail, discount, actItemHooks, getBiExt, extraBi, handleReceiveCoupon, joinTaskAndReceiveCoupon, onClickDetailBtn, onClickIconBtn, onClickItem, TaskReceiveStatus, CouponDetailDialog, OkIcon, AmountBox, ICON_CONFIG }
}

})